import { Controller } from "stimulus";

export default class extends Controller {
  declare inputTarget: HTMLInputElement;
  private isStorageSupported!: boolean;

  static get targets() {
    return ["input"];
  }

  public initialize() {
    this.isStorageSupported = typeof Storage !== "undefined";
  }

  public inputChanged() {
    if (this.isStorageSupported) {
      const inputValue = this.inputTarget.value;
      // TODO: migrate from DataMaps to Values
      sessionStorage.setItem(this.data.get("key") || "unset-key", inputValue);
    }
  }
}
